import { ref } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { useApi } from '@/composables/useApi';
import { useKioskStore } from '@/stores/useKioskStore';

export const useCatalogStore = defineStore('catalog', () => {
	const { request } = useApi();
	const { kioskId } = useKioskStore();
	const { locale } = storeToRefs(useKioskStore());

	const menu = ref(null);
	const product = ref(null);
	const allergens = ref(null);
	const categories = ref(null);

	async function fetchCatalog() {
		//@ts-ignore
		const [dataMenu, dataAllergens, dataCategories] = await Promise.all([
			request(`/api/${kioskId}/v2/menu`),
			request(`/api/${kioskId}/allergens`),
			request(`/api/${kioskId}/categories`),
		]);

		menu.value = (dataMenu[0]?.menuList || []).sort((a, b) => a.oid - b.oid);
		allergens.value = dataAllergens;
		categories.value = dataCategories;
	}

	function setProduct(value) {
		product.value = value;
	}

	function clearProduct() {
		product.value = null
	}

	function getCategoryName(id) {
		if (!categories.value) return id;

		const category = categories.value.find((item) => item.id === Number(id));
		return getTranslatedName(category);
	}

	function getTranslatedName(item, placeholder = 'Product name') {
		if (!item) return placeholder;

		return item.names?.[locale.value]
			|| (locale.value === 'cs' && item.names?.cz)
			|| item.names?.en
			|| item.name
			|| placeholder;
	}

	return {
		menu,
		product,
		allergens,
		categories,
		fetchCatalog,
		setProduct,
		clearProduct,
		getCategoryName,
		getTranslatedName
	};
});